import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20whimsical%20anime-style%20illustration%20of%20a%20mysterious%20curio%20shop%20facade%20at%20twilight%2C%20wooden%20storefront%20with%20glowing%20lanterns%2C%20magical%20artifacts%20visible%20through%20windows%2C%20soft%20golden%20and%20amber%20lighting%2C%20cozy%20fantasy%20atmosphere%2C%20watercolor-inspired%20art%20style%2C%20warm%20terracotta%20and%20cream%20tones%2C%20storybook%20illustration%20quality&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="洞洞杂货铺 - 高清漫画全集免费阅读"
          title="洞洞杂货铺高清漫画全集免费阅读下拉式 - 178漫画网"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <div className="mb-4">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm font-medium border border-white/20">
            超清画质 · 下拉式阅读 · 流畅体验
          </span>
        </div>

        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black text-white leading-tight tracking-wide">
          洞洞
        </h1>
        <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black text-white leading-tight tracking-wide mt-1">
          杂货铺
        </h2>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-white/80 max-w-lg leading-relaxed">
          高清漫画全集免费阅读下拉式，视觉盛宴尽在178漫画网
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/comic/dongdong-zahuopu"
            className="px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm md:text-base font-medium border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/category/healing"
            className="px-8 py-3 rounded-full text-white text-sm md:text-base font-medium hover:underline whitespace-nowrap cursor-pointer"
          >
            探索更多 &rarr;
          </Link>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-white/50 text-xs">向下滚动</span>
          <div className="w-5 h-8 rounded-full border border-white/30 flex items-start justify-center p-1">
            <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}